<template>
  <div class="live-list"
       v-ym-report:ANNIVERSARY_2021_LIVE_EXPOSE=""
  >
    <div class="live-list-card">
      <div ref="tab"
           class="live-list-card-tab"
      >
        <div v-for="(item, index) in liveList.list"
             :key="index"
             class="live-list-card-tab-item"
             :class="{ active: index === tabIndex }"
             @click="handleSwiperSlide(index)"
        >
          {{ item.date }}
        </div>
      </div>
      <div class="live-list-card-swiper">
        <swiper ref="liveSwiper"
                class="live-list-card-swiper-container"
                :options="swiperOption"
        >
          <swiper-slide class="live-list-card-swiper-item"
                        v-for="(item, index) in liveList.list"
                        :key="index"
          >
            <ym-img class="live-list-card-cover"
                    :src="item.cover"
                    @click="onClickSlide(item)"
                    v-ym-report:ANNIVERSARY_2021_LIVE_CLICK="{ date: item.date, isExpired: item.isExpired }"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <qr-code-popup :show.sync="showSubscribe"
                   title="请长按或扫描二维码<br>关注“少年商学院”进行预约"
                   :qrcode="require('@/pages/2021/Birthday/assets/img/video_code.jpg')"
    />
  </div>
</template>

<script>
  import QrCodePopup from '@/components/QrCodePopup';
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  import { decorator, after } from 'ym-reporter-vue';

  export default {
    name: 'LiveList',
    components: {
      swiper,
      swiperSlide,
      QrCodePopup,
    },
    props: {
      liveList: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        tabIndex: 0,
        realIndex: 0,
        liveSwiper: null,
        swiperOption: {
          loop: false,
          lazy: {
            loadPrevNext: true,
          },
          on: {
            slideChangeTransitionStart: () => {
              this.onSlideChangeTransitionStart();
            },
          },
        },
        firstReport: true,
        showSubscribe: false,
        isExpired: false,
      };
    },
    computed: {
      tabBook() {
        return this.liveList.list[this.tabIndex];
      },
    },
    watch: {
      tabIndex(val) {
        if (val < 5) {
          this.$refs.tab.scrollLeft = 0;
          return;
        }
        this.$refs.tab.scrollLeft = 999;
      },
    },
    methods: {
      handleSwiperSlide(index) {
        this.$refs.liveSwiper.swiper.slideTo(index, 0);
      },
      @decorator(after(function () {
        if (this.firstReport) {
          this.firstReport = false;
          return;
        }
        const params = { id: this.tabBook.id };
        this.$reporter.report('MARKETING_2021READINGDAY_SECKILL_DATE_CLICK', params);
      }))
      onSlideChangeTransitionStart() {
        this.tabIndex = this.$refs.liveSwiper.swiper.activeIndex;
      },
      onClickSlide(item) {
        this.isExpired = item.isExpired || false;
        this.showSubscribe = true;
      },
    },
    created() {
      this.realIndex = this.liveList.index;
      this.$nextTick(() => {
        this.handleSwiperSlide(this.realIndex);
      });
    },
  };
</script>

<style scoped lang="less">
   @import '~@/assets/styles/var.less';

   .live-list {
     &-card {
       position: relative;
       width: 100%;
       &-tab {
         width: 100%;
         height: 57px;
         margin-bottom: 4px;
         display: flex;
         flex-wrap: nowrap;
         overflow-x: scroll;
         overflow-y: hidden;
         &-item {
           position: relative;
           flex-shrink: 0;
           width: 146px;
           height: 57px;
           display: flex;
           align-items: center;
           justify-content: center;
           margin-right: 5px;
           color: @color-white;
           font-size: 24px;
           background: #6bd7c2;
           &:last-child {
             margin-right: 0;
           }
           &.active {
             background: #2b7e7c;
           }
         }
       }
       &-cover {
         width: 100%;
         height: 487px;
       }
     }
   }
</style>
